import axiosInstance from "../../translator";
import { requestManagerAPI as requestManager } from "../../constants/apis/apiEndpoints";

export const fetchRequestsList = async (urlParams) => {
  return axiosInstance
    .get(`${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchDeploymentList = async (urlParams) => {
  return axiosInstance
    .get(`${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchTrackRequest = async (urlParams) => {
  return axiosInstance
    .get(`${requestManager?.trackRequest}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveResendNotificationApi = async (id) => {
  return axiosInstance
    .get(`${requestManager?.resendNotification}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const notifyAgainApi = async (data) => {
  return axiosInstance
    .post(requestManager?.resendNotification, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveRequestApi = async (urlParams) => {
  return axiosInstance
    .get(`${requestManager.requestsList}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveDeploymentJobsApi = async (urlParams) => {
  return axiosInstance
    .get(`${requestManager?.deploymentList}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const setReqStatus = async (data) => {
  return axiosInstance
    .patch(
      `${requestManager?.setReqStatus}/${data?.currentReqId}`,
      data?.reqFormData
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveRequestLabListApi = async (urlParams) => {
  return axiosInstance
    .get(`${requestManager?.reqestLab}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createRequestTicketApi = async (data) => {
  return axiosInstance
    .post(`${requestManager?.reqestLab}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const requestApproveDeclineTicketApi = async (id, data) => {
  return axiosInstance
    .patch(`${requestManager?.reqestLab}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteRequestLabTicketApi = async (id) => {
  return axiosInstance
    .delete(`${requestManager?.reqestLab}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const exportRequestApi = async (urlParams) => {
  return axiosInstance
    .get(requestManager?.exportRequest, { params: urlParams })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const bulkUpdateRequestApi = async (data) => {
  return axiosInstance
    .post(`${requestManager?.bulkUpdateRequest}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
